export class Link {
    code:string | undefined;
    title:string | undefined;
    url:string | undefined;
    order:string | undefined;
    lang:string | undefined;
    country:string | undefined;

}
